// Shown on the trader cost calculator (web AIHub CalcTool, app CalcToolScreen).
// Owner, 2026-10-12 (Stage 1 of the Gemini migration): every figure the
// calculator shows is an ESTIMATE — freight rates, duty percentages, fees and
// profit projections are not a quotation and not a final cost — and every
// amount is in Saudi Riyals. Same text in the web and mobile repos (golden
// rule 1); keep the two files identical.
export const CALC_ESTIMATE_NOTICE = {
  ar: 'جميع الأرقام تقديرية للاسترشاد فقط: تكاليف الشحن والرسوم الجمركية والرسوم الأخرى وتوقعات الربح ليست عرض سعر ولا التزامًا نهائيًا، وقد تختلف التكلفة الفعلية. جميع المبالغ بالريال السعودي.',
  en: 'All figures are estimates for guidance only. Shipping costs, customs duties, other fees and profit projections are not a quotation or a final commitment, and actual costs may differ. All amounts are in Saudi Riyals (SAR).',
  zh: '所有数字均为估算，仅供参考。运费、关税、其他费用及利润预测并非报价或最终承诺，实际费用可能有所不同。所有金额均以沙特里亚尔（SAR）计。',
};

export function calcEstimateNotice(lang) {
  return CALC_ESTIMATE_NOTICE[lang] || CALC_ESTIMATE_NOTICE.ar;
}
